import {
  getAllRepeatConfig,
  getAllRepeatConfigContainBasic,
  getOffLineActivityConfig,
} from "@/api/clientApi/activity";
import { getLangKey, t } from "@/i18n/index.ts";
import {
  type RepeatActivityCfgMap,
  setRepeatActCfgDataMap,
} from "@/stores/activityStore";
import {
  PromotionsStoreInterface,
  changeTable,
  handleActivityList,
  promotionsStore,
  setPromotionsStore,
  updateFullContentActivityList,
} from "@/stores/promotionsStore";
import { userStore } from "@/stores/userStore";
import {
  GetOffLineActivityConfigRsp,
  OfflineActivityConfig,
} from "@/types/swaggerex/activity";

import {
  type RepeatCfgContainBasicMap,
  useRepeatActivityContainBasic,
} from "./useRepeatActivityContainBasic";

export function useActivity() {
  const { setRepeatCfgContainBasic } = useRepeatActivityContainBasic();
  // 获取优惠活动
  const getAllRepeatCfg = async () => {
    const res = await getAllRepeatConfig();
    setRepeatActCfgDataMap((res?.configs as RepeatActivityCfgMap) ?? {});
  };
  // 获取线下活动
  const getOffLineActivity = async (
    atypes: string[] = [],
    skip_rules: boolean = true,
  ) => {
    setPromotionsStore("isLoading", true);
    let res: GetOffLineActivityConfigRsp | undefined;
    try {
      res = await getOffLineActivityConfig(
        userStore.isLogin,
        atypes,
        skip_rules,
      )
        ?.then((res) => {
          setPromotionsStore("isLoading", false);
          return res;
        })
        .catch((err) => {
          setPromotionsStore("isLoading", false);
          return err;
        })
        .finally(() => {
          setPromotionsStore("isLoading", false);
        });
    } finally {
      setPromotionsStore("isLoading", false);
    }
    if (res?.offine_activity_config) {
      const list: PromotionsStoreInterface["activityList"] =
        res.offine_activity_config.sort((a, b) => a.sort - b.sort);
      setPromotionsStore("activityList", list);
      setPromotionsStore("chooseActivityList", handleActivityList(list));
    } else {
      setPromotionsStore("activityList", []);
      setPromotionsStore("chooseActivityList", []);
    }
    // 获取活动分类
    if (res?.offline_activity_category_config) {
      const list: PromotionsStoreInterface["categoryList"] = [
        { label: t("home.all"), value: "" },
      ];
      res.offline_activity_category_config.forEach((item) => {
        list.push({ label: item.name[getLangKey()], value: item._id });
      });
      setPromotionsStore("categoryList", list);
    } else {
      setPromotionsStore("categoryList", [{ label: t("home.all"), value: "" }]);
    }
    changeTable(promotionsStore.tabActive);
  };
  const getOffLineActivityDetail = async (atype: string) => {
    let config: OfflineActivityConfig | undefined = undefined;
    let tmpCfg: OfflineActivityConfig = {} as OfflineActivityConfig;
    tmpCfg = promotionsStore.fullContentActivityList[atype];

    if (tmpCfg && tmpCfg.content[getLangKey()]?.activity_text) {
      config = tmpCfg;
    }
    if (!config) {
      const res = await getOffLineActivityConfig(
        userStore.isLogin,
        [atype],
        false,
      );
      updateFullContentActivityList(
        atype,
        res?.offine_activity_config[0] ?? ({} as OfflineActivityConfig),
      );
      if (res?.offine_activity_config) {
        config = res.offine_activity_config[0];
      }
    }

    return config;
  };
  // 获取优惠活动包含基础设置
  const getAllRepeatCfgContainBasic = async () => {
    const res = await getAllRepeatConfigContainBasic();
    if (res?.configs) {
      setRepeatCfgContainBasic(res?.configs as RepeatCfgContainBasicMap);
    }
  };

  return {
    getAllRepeatCfg,
    getAllRepeatCfgContainBasic,
    getOffLineActivity,
    getOffLineActivityDetail,
  };
}
